import Glide from "@glidejs/glide";

window.addEventListener("turbo:load", () => {
  if (document.querySelectorAll(".glide").length) {
    new Glide(".glide", {
      gap: 0,
      rewind: false
    }).mount();
  }
});
